import {
  Button,
  FormControl,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { withStyles } from "@material-ui/styles";
import clsx from "clsx";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import { format } from "date-fns";
import HttpClient from "libs/utils/HttpClient";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import DatetimeService from "services/DatetimeService";
import PropTypes from "prop-types";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function createData(a, b, c) {
  return { a, b, c };
}

const useStyles = makeStyles((theme) => ({
  warpListVisa: {
    marginTop: 50,
  },
  warpButton: {
    marginTop: 30,
    display: "flex",
    justifyContent: "space-between",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  warpForm: {
    marginTop: 30,
  },
  warpTabs: {
    marginTop: 30,
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: "#F1F3F9",
    color: "#8898AA",
  },
  buttonViewDetail: {
    // width: 150,
    backgroundColor: "#00D0FF",
    marginRight: 10,
  },
  warpButtonDetail: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonStatusDetail: {
    backgroundColor: "white",
    padding: 5,
    borderRadius: "50%",
    boxShadow: "0px 0px 2px 2px rgba(23, 43, 77, 0.2)",
  },
  warpData: {
    marginTop: 20,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  indicator: {
    backgroundColor: "#1094D8",
    color: "white",
  },
  iconStatus: {
    color: "#2DCE98",
    marginRight: 5,
  },
  warpButtonSave: {
    textAlign: "right",
    marginTop: 30,
  },
  buttonSave: {
    marginLeft: 5,
    width: 120,
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  wrapDateControl: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    marginBottom: 15,
  },
  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
  dateControl: {
    marginRight: 5,
    width: "100%",
  },
  btnEdit: {
    color: "white",
    backgroundColor: "#2DCE98",
    marginLeft: 10,
  },
  btnRemove: {
    color: "white",
    backgroundColor: "#1094d8",
    marginLeft: 10,
  },
  warpRowDialog: {
    marginTop: 10,
  },
  dtitle: {
    color: "#40B8D4",
  },
  d2title: {
    color: "#172B4D",
    paddingBottom: 10,
  },
  textDialog: {
    width: "100%",
  },
  warpDialog: {
    padding: "30px",
    minWidth: "600px",
    minHeight: "200px",
  },
}));
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function ListPersonal() {
  const { t, i18n } = useTranslation();

  const classes = useStyles();
  const dispatch = useDispatch();
  //   const { list: holidays } = useSelector((state) => state.holiday);
  const [email_data, setEmail_data] = useState([]);
  const [date, setDate] = React.useState(new Date());
  const [dialogData, setDialogData] = React.useState(false);
  const [startDate, setStartDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [endDate, setEndDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const history = useHistory();
  const flDate = DatetimeService.getFirstAndLastDayOfMonth(new Date());
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("smartDate");

  useEffect(async () => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/personal/list?startDate=${startDate}&endDate=${endDate}`
      );

      console.log(response);

      setEmail_data(response.results);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }, []);

  useEffect(() => {
    setStartDate(flDate?.firstDate);
    setEndDate(flDate?.lastDate);
    getListByDate(flDate?.firstDate, flDate?.lastDate);
  }, []);

  const getListByDate = async (start, end) => {
    try {
      const response = await HttpClient.get(
        `/api/visaformadmin/personal/list?startDate=${moment(start).format(
          "YYYY-MM-DD"
        )}&endDate=${moment(end).format("YYYY-MM-DD")}`
      );
      console.log(response);

      if (response.status) {
        setEmail_data(response.results);
        return response;
      } else {
        setEmail_data([]);
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  const FilterSubject = (e) => {
    if (e !== "") {
      if (email_data) {
        const filter = email_data.filter((item) => {
          return (
            item.firstName.toLowerCase().includes(e.toLowerCase()) ||
            item.lastName.toLowerCase().includes(e.toLowerCase()) ||
            item.email.toLowerCase().includes(e.toLowerCase()) ||
            item.username.toLowerCase().includes(e.toLowerCase())
          );
        });
        setEmail_data(filter);
      }
    } else {
      setTimeout(function () {
        getListByDate(startDate, endDate);
      }, 500);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="List Personal" />

      <div className={classes.warpSubHeader}>
        <AdminTitle2 subTitle="List Personal" />
        <div className={classes.wrapDateControl}>
          <FormControl variant="outlined" className={clsx(classes.dateControl)}>
            <DatePicker
              label="Start Date"
              value={startDate}
              format="DD-MM-YYYY"
              onChange={async (_date) => {
                setStartDate(_date.format("YYYY-MM-DD"));
                // console.log(_date.format("YYYY-MM-DD"));
              }}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </FormControl>
          <FormControl variant="outlined" className={clsx(classes.dateControl)}>
            <DatePicker
              label="End Date"
              format="DD-MM-YYYY"
              value={endDate}
              onChange={async (_date) => {
                setEndDate(_date.format("YYYY-MM-DD"));
              }}
              renderInput={(params) => (
                <TextField {...params} helperText={null} />
              )}
            />
          </FormControl>
          <Button
            variant="contained"
            size="medium"
            color="primary"
            className={classes.buttonDialogSave}
            onClick={() => {
              getListByDate(startDate, endDate);
            }}
          >
            ค้นหา
          </Button>
        </div>
      </div>

      <div>
        <TextField
          onChange={(e) => FilterSubject(e.target.value)}
          label="Search "
          variant="outlined"
        />
      </div>
      {email_data?.length !== 0 ? (
        <div>
          <Typography style={{ marginTop: 5 }}>
            จำนวนข้อมูลทั้งหมด : {email_data?.length}
          </Typography>
        </div>
      ) : null}
      <div className={classes.warpData}>
        <TableContainer>
          <Table className={classes.table} aria-label="customized table">
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              // rowCount={props?.smartList.length}
            />
            <TableBody>
              {}
              {email_data !== null
                ? stableSort(email_data, getComparator(order, orderBy)).map(
                    (row, index) => (
                      <StyledTableRow key={row.personalID}>
                        <StyledTableCell
                          component="th"
                          scope="row"
                          style={{ textAlign: "center" }}
                        >
                          {row.createDate
                            ? format(
                                new Date(row.createDate),
                                "yyyy-MM-dd hh:mm:ss"
                              )
                            : null}
                        </StyledTableCell>
                        <StyledTableCell>{row.firstName}</StyledTableCell>
                        <StyledTableCell>{row.lastName}</StyledTableCell>
                        <StyledTableCell>{row.email}</StyledTableCell>
                        <StyledTableCell>{row.mobile}</StyledTableCell>
                        <StyledTableCell>{row.username}</StyledTableCell>
                        <StyledTableCell>{row.roleName}</StyledTableCell>
                        <StyledTableCell>
                          {row.isConfirmEmail ? "YES" : "NO"}
                        </StyledTableCell>

                        <StyledTableCell>
                          <div className={classes.warpButtonDetail}>
                            <Button
                              size="small"
                              color="primary"
                              className={classes.btnEdit}
                              onClick={async () => {
                                console.log(email_data[index]);
                                history.push(
                                  `/admin/setting/ListPerosnalDetail/${row.personalID}`
                                );
                              }}
                            >
                              View
                            </Button>
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    )
                  )
                : null}
            </TableBody>
          </Table>
        </TableContainer>
        {email_data?.length === 0 ? <center>No Record</center> : null}
      </div>
    </Paper>
  );
}

const headCells = [
  {
    id: "createDate",
    numeric: false,
    disablePadding: false,
    label: "Registered Date.",
  },
  {
    id: "firstName",
    numeric: false,
    disablePadding: false,
    label: "First name",
  },
  {
    id: "lastName",
    numeric: false,
    disablePadding: false,
    label: "Last name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "mobile",
    numeric: false,
    disablePadding: false,
    label: "Mobile",
  },
  {
    id: "username",
    numeric: false,
    disablePadding: false,
    label: "Username",
  },
  {
    id: "roleName",
    numeric: false,
    disablePadding: false,
    label: "User Type",
  },
  {
    id: "isConfirmEmail",
    numeric: false,
    disablePadding: false,
    label: "Activated Email",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
    disabled: true,
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const classes = useStyles();
  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            className={classes.tableHead}
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              // disabled={headCell?.disabled || true}
              disabled={headCell?.disabled}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default ListPersonal;
